

























import { Component, Vue } from 'vue-property-decorator';
import CarNew from '@/components/Car/CarNew.vue';

@Component({
  components: {
    CarNew,
  },
})
export default class CarNewButton extends Vue {
  public showDialog = false;
}
